(function(){
    'use strict'

    angular.module('app.devengados')
    .factory('DevengadosService', DevengadosService);

    DevengadosService.$inject = ['$http', '$q', 'apiSettings'];

    function DevengadosService($http, $q, apiSettings) {

        var api = {
            getAll: getAll,
            getById: getById,
            save: save,
            update:update,
            remove: remove,
            getAllOtros: getAllOtros,
            getByIdOtros: getByIdOtros,
            saveOtros: saveOtros,
            updateOtros:updateOtros,
            removeOtros: removeOtros
        };

        return api;

        function getAll(){

            var url = apiSettings.apiBaseUrl + 'api/devengados';
            
            return $http.get(url)
            .then(getAllSuccess, getAllError);

            function getAllSuccess(response){
                return response.data;
            };

            function getAllError(error) {
                return $q.reject(error);
            }
        };

        function getById(devengadoId){

            var url = apiSettings.apiBaseUrl + 'api/devengados/' + devengadoId;
            
            return $http.get(url)
            .then(getByIdSuccess, getByIdError);

            function getByIdSuccess(response){
                return response.data;
            };

            function getByIdError(error) {
                return $q.reject(error);
            }
        };

        function save(devengado){

            devengado.id = 0;

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/devengados',  
                method: 'POST',  
                data: devengado
            });  
            return response;
        };

        function update(devengado){

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/devengados',  
                method: 'PUT',  
                data: devengado
            });  
            return response;
        };

        function remove(devengado){

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/devengados',  
                method: 'DELETE', 
                headers: { 
                    'Content-Type': 'application/json' },
                data: devengado
            });  
            return response;
        };

        function getAllOtros(){

            var url = apiSettings.apiBaseUrl + 'api/otros-devengados';
            
            return $http.get(url)
            .then(getAllSuccess, getAllError);

            function getAllSuccess(response){
                return response.data;
            };

            function getAllError(error) {
                return $q.reject(error);
            }
        };

        function getByIdOtros(devengadoId){

            var url = apiSettings.apiBaseUrl + 'api/otros-devengados/' + devengadoId;
            
            return $http.get(url)
            .then(getByIdSuccess, getByIdError);

            function getByIdSuccess(response){
                return response.data;
            };

            function getByIdError(error) {
                return $q.reject(error);
            }
        };

        function saveOtros(devengado){

            devengado.id = 0;

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/otros-devengados',  
                method: 'POST',  
                data: devengado
            });  
            return response;
        };

        function updateOtros(devengado){

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/otros-devengados',  
                method: 'PUT',  
                data: devengado
            });  
            return response;
        };

        function removeOtros(devengado){

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/otros-devengados',  
                method: 'DELETE', 
                headers: { 
                    'Content-Type': 'application/json' },
                data: devengado
            });  
            return response;
        };

    };

})();        